export default __webpack_public_path__ + "static/media/bell.4fe58123.mp3";